import React from "react";
import get from "lodash/get";
import includes from "lodash/includes";
import { useTranslation } from "react-i18next";
import BackArrowButton from "../parts/back-arrow-button";
import submit from "submit-form";
import { getUserToRequest } from "./dashboard/settings/manage-coaches/utils/manage-coaches-utils";

function View(props) {
  const { t } = useTranslation("auth");
  const onBack = (e) => {
    e.preventDefault();
    const url = `/logout`;
    submit(url, {
      method: "GET",
    });
  };

  return (
    <div id="login-wrapper">
      <form
        method="POST"
        className="h-screen flex flex-col items-center justify-center gap-6"
        data-noreset
        role="upgrade"
      >
        <div role="upgrade-content">
          <div className="flex gap-2 items-center">
            <BackArrowButton onBack={onBack} classNames="mobile-hidden" />
            <img
              src="/img/new-icons/MSB-full-logo-extended.svg"
              alt={t("upgrade1.logoAlt")}
              className="h-12 mobile-hidden"
            />
            <div className="only-show-mobile" role="msb-logo">
              <img
                src="/img/new-icons/msb-logo-not-extended.svg"
                alt={t("upgrade1.logoAlt")}
                className="h-12"
              />
            </div>
          </div>
          <div className="intro" role="upgrade-description">
            <h4 className="mobile-hidden">
              {t("upgrade1.accessRequiredDescription")}
            </h4>
            <h4 className="only-show-mobile">
              {t("upgrade1.accessRequiredTitle")}
            </h4>
            <span className="only-show-mobile">
              {t("upgrade1.accessRequiredDescription")}
            </span>
          </div>
          <button
            onClick={onBack}
            type="button"
            className="only-show-mobile"
            data-button-type="primary"
          >
            <a href="/logout" target="_blank" rel="noopener">
              {t("upgrade1.backToLogin")}
            </a>
          </button>
        </div>
      </form>
    </div>
  );
}

const Upgrade1 = (app) => {
  app.get("/upgrade-1", ({ res, locals, flash, momentTZ }) => {
    const { activeUser, organizationOwner, query } = locals;
    const userToRequest = getUserToRequest(activeUser, organizationOwner);
    const plan = get(userToRequest, "stripe.plan", false);

    if (!query.hideHeader) {
      if (!activeUser) {
        res.redirect("/login");
        return;
      }

      // if the user's plan is a paid account, redirect them to see their subscription
      if (
        !includes(["none", "launch_freeTrial", "free_trial"], plan) &&
        !userToRequest.subscription &&
        !userToRequest.membership
      ) {
        res.redirect("/dashboard/settings/subscription");
        return;
      }
    }

    res.body = <View />;
  });
};

export default Upgrade1;
